export default "__VITE_ASSET__7XOj9e9w__"